import { useCallback, useEffect, useState } from "react";
import "./App.css";
import logo from "./assets/dm-logo.png";

const getAdminToken = () => localStorage.getItem("adminToken");

function App() {
  const API = "https://backend-zy7l.onrender.com";

  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [stockFilter, setStockFilter] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProducts, setShowProducts] = useState(false);
  const [infoPage, setInfoPage] = useState("");
  const [editId, setEditId] = useState(null);
  const [adminMode, setAdminMode] = useState(window.location.hash === "#admin");

  const [isAdmin, setIsAdmin] = useState(() => !!getAdminToken());
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const [showCheckout, setShowCheckout] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [cartMessage, setCartMessage] = useState("");
  const [customer, setCustomer] = useState({
    customerName: "",
    email: "",
    phone: "",
    address: ""
  });

  const [form, setForm] = useState({
    name: "",
    price: "",
    category: "",
    subcategory: "",
    brand: "",
    image: "",
    description: "",
    vin: "",
    stock: "",
  });
const [selectedImage, setSelectedImage] = useState(null);
const [imagePreview, setImagePreview] = useState("");
const [uploadingImage, setUploadingImage] = useState(false);
  const authHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAdminToken()}`
  });

  useEffect(() => {
    const onHashChange = () => setAdminMode(window.location.hash === "#admin");
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const loadProducts = useCallback(() => {
    fetch(`${API}/api/products`)
      .then((res) => res.json())
      .then((data) => setProducts(data))
      .catch((err) => console.log(err));
  }, [API]);

  const loadOrders = useCallback(() => {
    const token = getAdminToken();
    if (!token) return;

    fetch(`${API}/api/orders`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => res.json())
      .then((data) => {
  if (Array.isArray(data)) {
    setOrders(data);
  } else {
    localStorage.removeItem("adminToken");
    setIsAdmin(false);
    setOrders([]);
  }
})
      .catch((err) => console.log(err));
  }, [API]);

  useEffect(() => {
    loadProducts();
    if (getAdminToken()) loadOrders();
  }, [loadProducts, loadOrders]);

  const loginAdmin = async () => {
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      if (data.token) {
        localStorage.setItem("adminToken", data.token);
        setIsAdmin(true);
        setEmail("");
        setPassword("");
        loadOrders();
        alert("Admin login successful");
      } else {
        alert("Wrong email or password");
      }
    } catch (error) {
      console.log(error);
      alert("Server error");
    }
  };

  const logoutAdmin = () => {
    localStorage.removeItem("adminToken");
    setIsAdmin(false);
    setOrders([]);
    setEditId(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCustomerChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setForm({
      name: "",
      price: "",
      category: "",
      subcategory: "",
      brand: "",
      image: "",
      description: "",
      vin: "",
      stock: ""
    });
    setEditId(null);
  };
const handleImageSelect = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  setSelectedImage(file);
  setImagePreview(URL.createObjectURL(file));
};

const uploadImage = async () => {
  if (!selectedImage) {
    alert("Please choose an image first.");
    return;
  }

  try {
    setUploadingImage(true);

    const formData = new FormData();
    formData.append("image", selectedImage);

    
   const res = await fetch(`${API}/api/upload`, {
  method: "POST",
  headers: {
    Authorization: `Bearer ${getAdminToken()}`,
  },
  body: formData,
});

    const data = await res.json();
    console.log(data);

    setForm((prev) => ({
      ...prev,
      image: data.imageUrl,
    }));

    setImagePreview(data.imageUrl);

    alert("Image uploaded!");
  } catch (err) {
    console.error(err);
    alert("Upload failed");
  } finally {
    setUploadingImage(false);
  }
};




  const addProduct = async () => {
    if (!form.name || !form.price) {
      alert("Name and price are required");
      return;
    }

    await fetch(`${API}/api/products`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({
  ...form,
  price: Number(form.price),
  stock: Number(form.stock)
})
    });

    resetForm();
    loadProducts();
    alert("Product added!");
  };

  const startEdit = (product) => {
    setEditId(product._id);
    setForm({
      name: product.name || "",
      price: product.price || "",
      category: product.category || "",
      subcategory: product.subcategory || "",
      brand: product.brand || "",
      image: product.image || "",
      description: product.description || "",
      vin: product.vin || "",
      stock: product.stock || "",
    });
    window.location.hash = "admin";
    setAdminMode(true);
  };

  const updateProduct = async () => {
    await fetch(`${API}/api/products/${editId}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
  ...form,
  price: Number(form.price),
  stock: Number(form.stock)
})
    });

    resetForm();
    loadProducts();
    alert("Product updated!");
  };

  const deleteProduct = async (id) => {
    if (!window.confirm("Delete this product?")) return;

    await fetch(`${API}/api/products/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${getAdminToken()}` }
    });

    loadProducts();
    alert("Product deleted!");
  };

  const deleteOrder = async (id) => {
    if (!window.confirm("Delete this order?")) return;

    await fetch(`${API}/api/orders/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${getAdminToken()}` }
    });

    loadOrders();
    alert("Order deleted!");
  };

 const updateOrder = async (id, updates) => {
  await fetch(`${API}/api/orders/${id}/status`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(updates)
  });

  loadOrders();
};
const addToCart = (product) => {
  const currentQuantity = cart.filter(
    (item) => item._id === product._id
  ).length;

  if (currentQuantity >= Number(product.stock)) {
    setCartMessage(`Only ${product.stock} available in stock`);

    setTimeout(() => {
      setCartMessage("");
    }, 2000);

    return;
  }

  setCart((prevCart) => [...prevCart, product]);
  setCartMessage(`${product.name} added to cart`);

  setTimeout(() => {
    setCartMessage("");
  }, 2000);
};
 
  const removeOneFromCart = (productId) => {
  const indexToRemove = cart.findIndex(
    (item) => item._id === productId
  );

  if (indexToRemove === -1) return;

  setCart(
    cart.filter((_, index) => index !== indexToRemove)
  );

  };
const groupedCart = Object.values(
  cart.reduce((acc, item) => {
    if (!acc[item._id]) {
      acc[item._id] = {
        ...item,
        quantity: 0
      };
    }

    acc[item._id].quantity += 1;
    return acc;
  }, {})
);
  const clearCart = () => setCart([]);

  const total = cart.reduce((sum, item) => sum + Number(item.price), 0);
const placeOrder = async () => {
  if (isPlacingOrder) return;

  if (
    !customer.customerName ||
    !customer.email ||
    !customer.phone ||
    !customer.address
  ) {
    alert("Please fill all checkout fields");
    return;
  }

  if (cart.length === 0) {
    alert("Cart is empty");
    return;
  }

  setIsPlacingOrder(true);

  try {
    const response = await fetch(`${API}/api/orders`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...customer,
        items: cart
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Order failed");
    }

    alert("Order placed successfully!");

    setCart([]);
    setShowCheckout(false);
    setCustomer({
      customerName: "",
      email: "",
      phone: "",
      address: ""
    });

    if (isAdmin) loadOrders();
  } catch (error) {
    alert(error.message || "Order failed. Please try again.");
  } finally {
    setIsPlacingOrder(false);
  }
};
  const mainCategories = [
  {

    name: "Suspension Parts",
    image: "/assets/categories/suspension.jpg",
    values: ["suspension", "suspension parts"]
  },
  {
    name: "Filters",
    image: "/assets/categories/filters.jpg",
    values: ["filters", "filter"]
  },
  {
    name: "Body Parts",
    image: "/assets/categories/body-parts.jpg",
    values: ["body parts","body"]
  },
  {
    name: "Chrome Accessories",
    image: "/assets/categories/chrome-accessories.jpg",
    values: ["chrome accessories", "chrome"]
  },
  {
    name: "Brake Parts",
    image: "/assets/categories/brake-parts.jpg",
    values: ["brakes", "brake", "brake parts"]
  },
  {
    name: "Deer Guards",
    image: "/assets/categories/deer-guards.jpg",
    values: ["deer guards", "deer guard"]
  },
  {
    name: "Valves",
    image: "/assets/categories/valves.jpg",
    values: ["valves", "valve"]
  },
  {
    name: "Other Parts",
    image: "/assets/categories/other-parts.jpg",
    values: ["others", "other parts", "other"]
  }
];
const subcategoriesByCategory = {
  Filters: [
    "Air Filters",
    "Oil Filters",
    "Fuel Filters",
    "Cabin Filters",
    "DEF Filters"
  ],

  "Suspension Parts": [
    "Air Springs",
    "Shock Absorbers",
    "Leaf Springs",
    "Torque Rods",
    "Suspension Bushings"
  ],
"Brake Parts": [
  "Brake Chambers",
  "Brake Shoes",
  "Brake Drums",
  "Brake Rotors",
  "Brake Slack Adjusters"
],
"Body Parts": [
  "Bumpers",
  "Hoods",
  "Fenders",
  "Grilles",
  "Mirrors"
],
"Chrome Accessories": [
  "Chrome Bumpers",
  "Chrome Grilles",
  "Chrome Mirrors",
  "Chrome Covers",
  "Chrome Trim"
],
"Deer Guards": [
  "Full Deer Guards",
  "Grille Guards",
  "Bumper Guards",
  "Mounting Brackets",
  "Replacement Parts"
],
"Valves": [
  "Air Brake Valves",
  "Relay Valves",
  "Check Valves",
  "Control Valves",
  "Leveling Valves"
],
"Other Parts": [
  "Lighting",
  "Electrical Parts",
  "Interior Parts",
  "Exterior Accessories",
  "Miscellaneous Parts"
]
};
const productMatchesCategory = (product, categoryName) => {
  if (!categoryName) return true;

  const category = mainCategories.find(
    (item) => item.name === categoryName
  );

  if (!category) return false;

  const productCategory = (product.category || "").toLowerCase().trim();

  return category.values.includes(productCategory);
};

const openCategory = (categoryName) => {
  setInfoPage("");
  setSelectedCategory(categoryName);
  setSelectedSubcategory("");
  setSearch("");
  setShowProducts(true);

  setTimeout(() => {
    document.getElementById("products")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 0);
};

const showAllProducts = () => {
  setInfoPage("");
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSearch("");
  setShowProducts(true);

  setTimeout(() => {
    document.getElementById("products")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 0);
};
const showShippingReturns = () => {
  setInfoPage("shipping");
  setShowProducts(false);
  setSelectedProduct(null);
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSearch("");

  setTimeout(() => {
    document.getElementById("info-page")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 0);
};
const showAboutUs = () => {
  setInfoPage("about");
  setShowProducts(false);
  setSelectedProduct(null);
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSearch("");

  setTimeout(() => {
    document.getElementById("info-page")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 0);
};
const showPrivacyPolicy = () => {
  setInfoPage("privacy");
  setShowProducts(false);
  setSelectedProduct(null);
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSearch("");

  setTimeout(() => {
    document.getElementById("info-page")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 0);
};
const showTermsConditions = () => {
  setInfoPage("terms");
  setShowProducts(false);
  setSelectedProduct(null);
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSearch("");

  setTimeout(() => {
    document.getElementById("info-page")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, 0);
};
const availableBrands = [
  ...new Set(
    products
      .map((p) => (p.brand || "").trim())
      .filter(Boolean)
  )
].sort();
  const filteredProducts = products.filter((p) => {
  const searchText = search.toLowerCase().trim();

  const matchesSearch =
    !searchText ||
    p.name?.toLowerCase().includes(searchText) ||
    p.category?.toLowerCase().includes(searchText) ||
    p.vin?.toLowerCase().includes(searchText) ||
    p.brand?.toLowerCase().includes(searchText) ||
    p.description?.toLowerCase().includes(searchText);

const matchesCategory = productMatchesCategory(
  p,
  selectedCategory
);

const matchesSubcategory =
  !selectedSubcategory ||
  (p.subcategory || "").toLowerCase().trim() ===
    selectedSubcategory.toLowerCase().trim();
const matchesBrand =
  !selectedBrand ||
  (p.brand || "").toLowerCase().trim() ===
    selectedBrand.toLowerCase().trim();
const productPrice = Number(p.price) || 0;

const matchesPrice =
  (!minPrice || productPrice >= Number(minPrice)) &&
  (!maxPrice || productPrice <= Number(maxPrice));
const productStock = Number(p.stock) || 0;

const matchesStock =
  !stockFilter ||
  (stockFilter === "in" && productStock > 0) ||
  (stockFilter === "out" && productStock <= 0);
return (
  matchesSearch &&
  matchesCategory &&
  matchesSubcategory &&
  matchesBrand &&
  matchesPrice &&
  matchesStock
);

 
});
 const sortedProducts = [...filteredProducts].sort((a, b) => {
  if (sortOption === "price-low") {
    return Number(a.price) - Number(b.price);
  }

  if (sortOption === "price-high") {
    return Number(b.price) - Number(a.price);
  }

  if (sortOption === "name-az") {
    return (a.name || "").localeCompare(b.name || "");
  }

  return 0;
});
  return (
    <div className={`app ${!showProducts && !adminMode && !infoPage ? "homepage-active" : ""}`}>
{cartMessage && (
  <div className="cart-message">
    {cartMessage}
  </div>
)}
<div className="top-contact-bar">
  <div className="top-contact-inner">
    <a href="tel:+13122662433">+1 312 266 2433</a>
    <span>|</span>
    <a href="tel:+13122899330">+1 312 289 9330</a>
    <span>|</span>
    <a href="tel:+13122485241">+1 312 248 5241</a>
    <span>|</span>
    <a href="mailto:info@dmtruckparts.com">
      info@dmtruckparts.com
    </a>
  </div>
</div>
      <header className="main-header">
  <div className="header-brand">
    <img src={logo} alt="DM Truck Parts" />

    <div className="header-brand-text">
      <h2>
        <span>DM</span> TRUCK PARTS
      </h2>
      <p>HEAVY DUTY SOLUTIONS</p>
    </div>
  </div>

  <nav className="header-nav">
    <a href="#products" onClick={showAllProducts}>
  Shop Parts
</a>
    <div className="nav-dropdown">
  <button className="dropdown-button" type="button">
    Categories
  </button>

 <div className="dropdown-menu">
  {mainCategories.map((category) => (
    <a
      href="#products"
      key={category.name}
      onClick={() => openCategory(category.name)}
    >
      {category.name}
    </a>
  ))}

  <a href="#products" onClick={showAllProducts}>
    All Parts
  </a>
</div>
</div>
   <a
  href="#why"
  onClick={() => {
    setInfoPage("");
    setSelectedCategory("");
    setSelectedSubcategory("");
    setSearch("");
    setShowProducts(false);

    setTimeout(() => {
      document.getElementById("why")?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 0);
  }}
>
  Why Choose Us
</a>
    
  </nav>
<div className="header-search">
  <input
    type="text"
    placeholder="Search parts..."
    value={search}
    onChange={(e) => {
      const value = e.target.value;
      setSearch(value);
      setInfoPage("");
      setSelectedCategory("");
      setSelectedSubcategory("");
      setShowProducts(value.trim() !== "");
    }}
  />
</div>
<a
  className="header-cart"
  href="#cart"
  aria-label="Cart"
 onClick={() => {
  setInfoPage("");
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSearch("");
  setShowProducts(true);
}}
> <span className="cart-icon">
  <svg
    viewBox="0 0 24 24"
    width="25"
    height="25"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M3 3h2l2.4 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 6H6" />
    <circle cx="10" cy="19" r="1.5" />
    <circle cx="18" cy="19" r="1.5" />
  </svg>
</span>

  {cart.length > 0 && (
    <span className="cart-badge">{cart.length}</span>
  )}
</a>
</header>
   
      <section

  className={`categories ${showProducts || adminMode || infoPage ? "homepage-hidden" : ""}`}
  id="categories"
>


  <div className="section-title main-categories-title">
    <h2>MAIN CATEGORIES</h2>
  </div>

  <div className="main-categories-grid">
    {mainCategories.map((category) => {
      const count = products.filter((product) =>
        productMatchesCategory(product, category.name)
      ).length;

      return (
        <button
          key={category.name}
          className="main-category-card"
          onClick={() => openCategory(category.name)}
        >
          <div className="main-category-image">
  {category.image ? (
    <img src={category.image} alt={category.name} />
  ) : (
    <span>{category.name}</span>
  )}
</div>

          <div className="main-category-info">
            <h3>{category.name}</h3>
            <p>
  {count} {count === 1 ? "product" : "products"}
</p>
          </div>
        </button>
      );
    })}
  </div>

</section>

      {adminMode && (
        <section className="admin" id="admin">
          <h2>ADMIN PANEL</h2>

          {!isAdmin ? (
            <div className="admin-form">
              <input
                type="email"
                placeholder="Admin email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <input
                type="password"
                placeholder="Admin password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button onClick={loginAdmin}>LOGIN</button>
            </div>
          ) : (
            <div className="admin-form">
              <button onClick={logoutAdmin} className="gray-btn">
                LOGOUT ADMIN
              </button>

              <h3>{editId ? "EDIT PRODUCT" : "ADD PRODUCT"}</h3>

              <input name="name" placeholder="Product Name" value={form.name} onChange={handleChange} />
              <input name="price" placeholder="Price" value={form.price} onChange={handleChange} />
              <select
  name="category"
  value={form.category}
  onChange={(e) => {
    setForm({
      ...form,
      category: e.target.value,
      subcategory: ""
    });
  }}
>
  <option value="">Select Category</option>

  {mainCategories.map((category) => (
    <option key={category.name} value={category.name}>
      {category.name}
    </option>
  ))}
</select>
<select
  name="subcategory"
  value={form.subcategory}
  onChange={handleChange}
  disabled={!form.category}
>
  <option value="">Select Subcategory</option>

  {(subcategoriesByCategory[form.category] || []).map((subcategory) => (
    <option key={subcategory} value={subcategory}>
      {subcategory}
    </option>
  ))}
</select>
<input
  name="brand"
  placeholder="Brand"
  value={form.brand}
  onChange={handleChange}
/>
              <div className="image-upload-box">

  <input
    type="file"
    accept="image/*"
    onChange={handleImageSelect}
  />

  {imagePreview && (
    <img
      src={imagePreview}
      alt="Preview"
      style={{
        width: "180px",
        marginTop: "10px",
        borderRadius: "8px"
      }}
    />
  )}

  <button
    type="button"
    onClick={uploadImage}
    disabled={uploadingImage}
  >
    {uploadingImage ? "UPLOADING..." : "UPLOAD IMAGE"}
  </button>

  <input
    name="image"
    placeholder="Image URL"
    value={form.image}
    readOnly
  />

</div>
              <input name="vin" placeholder="VIN / Fitment" value={form.vin} onChange={handleChange} />
<input
  name="stock"
  type="number"
  placeholder="Stock Quantity"
  value={form.stock}
  onChange={handleChange}
/>
              <textarea name="description" placeholder="Description" value={form.description} onChange={handleChange} />

              {editId ? (
                <>
                  <button onClick={updateProduct}>UPDATE PRODUCT</button>
                  <button onClick={resetForm} className="gray-btn">CANCEL EDIT</button>
                </>
              ) : (
                <button onClick={addProduct}>ADD PRODUCT</button>
              )}
            </div>
          )}
        </section>
      )}

      {adminMode && isAdmin && (
        <section className="admin" id="orders">
          <h2>ORDERS PANEL</h2>

          <div className="orders-grid">
            {orders.length === 0 ? <p>No orders yet</p> : null}

            {orders.map((order) => (
              <div className="order-card" key={order._id}>
                <h3>{order.customerName}</h3>
                <p><b>Email:</b> {order.email}</p>
                <p><b>Phone:</b> {order.phone}</p>
                <p><b>Address:</b> {order.address}</p>

                <p><b>Status:</b> <span className="status">{order.status || "New"}</span></p>

                <select
                  value={order.status || "New"}
                  onChange={(e) =>
  updateOrder(order._id, { status: e.target.value })
}
                >
                  <option>New</option>
                  <option>Paid</option>
                  <option>Processing</option>
                  <option>Shipped</option>
                  <option>Delivered</option>
                  <option>Completed</option>
                  <option>Cancelled</option>
                </select>
<div className="tracking-fields">
  <input
    type="text"
    placeholder="Carrier (UPS, FedEx, USPS...)"
    defaultValue={order.carrier || ""}
    onBlur={(e) =>
      updateOrder(order._id, { carrier: e.target.value })
    }
  />

  <input
    type="text"
    placeholder="Tracking Number"
    defaultValue={order.trackingNumber || ""}
    onBlur={(e) =>
      updateOrder(order._id, { trackingNumber: e.target.value })
    }
  />
</div>
                <h4>Items:</h4>
                {order.items?.map((item, index) => (
                  <p key={index}>- {item.name} (${item.price})</p>
                ))}

                <h3>Total: ${order.total}</h3>

                <button onClick={() => deleteOrder(order._id)} className="red-btn">
                  DELETE ORDER
                </button>
              </div>
            ))}
          </div>
        </section>
      )}

      <section
  className={`products-section ${!showProducts && !adminMode ? "products-hidden" : ""}`}
  id="products"
>
{selectedProduct && (
  <div className="product-detail">
    <button
      type="button"
      className="back-to-products"
      onClick={() => setSelectedProduct(null)}
    >
      ← Back to Products
    </button>

    <div className="product-detail-content">
      <div className="product-detail-image">
        {selectedProduct.image ? (
          <img
            src={selectedProduct.image}
            alt={selectedProduct.name}
          />
        ) : (
          <div className="no-image">DM</div>
        )}
      </div>

      <div className="product-detail-info">
        <h1>{selectedProduct.name}</h1>

        <p>{selectedProduct.description}</p>

        <p>
          <strong>Fitment:</strong>{" "}
          {selectedProduct.vin || "Universal"}
        </p>

        <p>
          <strong>Stock:</strong>{" "}
          {Number(selectedProduct.stock) || 0}
        </p>

<h2>
  ${Number(selectedProduct.price).toFixed(2)}
</h2>

{Number(selectedProduct.stock) > 0 ? (
  <button onClick={() => addToCart(selectedProduct)}>
    ADD TO CART
  </button>
) : (
  <button className="sold-out-btn" disabled>
    SOLD OUT
  </button>
)}
        
      </div>
    </div>
  </div>
)}

{showProducts && selectedCategory && !selectedProduct && (
  <div className="category-page-title">
    <h2>{selectedCategory}</h2>
  </div>
)}


   <div
  className={`products-layout ${
    selectedCategory && subcategoriesByCategory[selectedCategory]
      ? "with-sidebar"
      : ""
  }`}
  style={{ display: selectedProduct ? "none" : undefined }}
>
{selectedCategory &&
  subcategoriesByCategory[selectedCategory] && (
    <aside className="category-sidebar">
     

     
      {subcategoriesByCategory[selectedCategory].map((subcategory) => (
        <button
          type="button"
          key={subcategory}
          className={
            selectedSubcategory === subcategory ? "active" : ""
          }
          onClick={() => {
            setSelectedSubcategory(subcategory);
            setSearch("");
          }}
        >
          {subcategory}
        </button>
      ))}
    </aside>
  )}
          <div className="products-grid">
<div className="product-filters">
  <select
    value={selectedBrand}
    onChange={(e) => setSelectedBrand(e.target.value)}
  >
    <option value="">All Brands</option>

    {availableBrands.map((brand) => (
      <option key={brand} value={brand}>
        {brand}
      </option>
    ))}
  </select>

  <input
    type="number"
    placeholder="Min Price"
    value={minPrice}
    onChange={(e) => setMinPrice(e.target.value)}
    min="0"
  />

  <input
    type="number"
    placeholder="Max Price"
    value={maxPrice}
    onChange={(e) => setMaxPrice(e.target.value)}
    min="0"
  />
<select
  value={stockFilter}
  onChange={(e) => setStockFilter(e.target.value)}
>
  <option value="">All Stock</option>
  <option value="in">In Stock</option>
  <option value="out">Sold Out</option>
</select>
<select
  value={sortOption}
  onChange={(e) => setSortOption(e.target.value)}
>
  <option value="">Sort By</option>
  <option value="price-low">Price: Low to High</option>
  <option value="price-high">Price: High to Low</option>
  <option value="name-az">Name: A-Z</option>
</select>
  <button
    type="button"
    onClick={() => {
      setSelectedBrand("");
      setMinPrice("");
      setMaxPrice("");
      setStockFilter("");
      setSortOption("");
    }}
  >
    Clear Filters
  </button>
</div>


{filteredProducts.length === 0 && (
  <div className="no-products-message">
    No products found.
  </div>
)}
{sortedProducts.map((p) => (
              <div
  className="product-card"
  key={p._id}
  onClick={() => setSelectedProduct(p)}
>
                {p.image ? (
                  <img src={p.image} alt={p.name} />
                ) : (
                  <div className="no-image">DM</div>
                )}

                <div className="product-info">
                  
                  <h3>{p.name}</h3>
                  <p className="product-desc">{p.description}</p>
                  <p className="fitment">Fitment: {p.vin || "Universal"}</p>
<p className="stock">
  Stock: {Number(p.stock) || 0}
</p>
                  <p className="price">${p.price}</p>

                  {Number(p.stock) > 0 ? (
  <button onClick={() => addToCart(p)}>
    ADD TO CART
  </button>
) : (
  <button className="sold-out-btn" disabled>
    SOLD OUT
  </button>
)}

                  {adminMode && isAdmin && (
                    <>
                      <button onClick={() => startEdit(p)} className="yellow-btn">
                        EDIT PRODUCT
                      </button>

                      <button onClick={() => deleteProduct(p._id)} className="red-btn">
                        DELETE PRODUCT
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>

          <aside className="cart" id="cart">
            <h3>Cart Summary</h3>

            {cart.length === 0 ? <p>No items in cart.</p> : null}

{groupedCart.map((item) => (
  <div className="cart-item" key={item._id}>
    <span>{item.name}</span>

    <div className="cart-quantity">
      <button onClick={() => removeOneFromCart(item._id)}>
        −
      </button>

      <span>{item.quantity}</span>

      <button
        onClick={() => addToCart(item)}
        disabled={item.quantity >= Number(item.stock)}
      >
        +
      </button>
    </div>

    <b>
      ${(Number(item.price) * item.quantity).toFixed(2)}
    </b>
  </div>
))}
            <hr />
            <h4>Total: ${total}</h4>

            {cart.length > 0 && (
              <>
                <button className="checkout" onClick={() => setShowCheckout(!showCheckout)}>
                  {showCheckout ? "HIDE CHECKOUT" : "CHECKOUT"}
                </button>

                <button className="checkout gray-btn" onClick={clearCart}>
                  CLEAR CART
                </button>
              </>
            )}

            {showCheckout && (
              <div className="checkout-form">
                <h4>Checkout Information</h4>

                <input
                  name="customerName"
                  placeholder="Full Name"
                  value={customer.customerName}
                  onChange={handleCustomerChange}
                />

                <input
                  name="email"
                  placeholder="Email"
                  value={customer.email}
                  onChange={handleCustomerChange}
                />

                <input
                  name="phone"
                  placeholder="Phone"
                  value={customer.phone}
                  onChange={handleCustomerChange}
                />

                <textarea
                  name="address"
                  placeholder="Shipping Address"
                  value={customer.address}
                  onChange={handleCustomerChange}
                />
<button
  className="checkout"
  onClick={placeOrder}
  disabled={isPlacingOrder}
>
  {isPlacingOrder ? "PROCESSING..." : "PLACE ORDER"}
</button>
                              </div>
            )}
          </aside>
        </div>
      </section>

      <section
 className={`why ${showProducts || adminMode || infoPage ? "homepage-hidden" : ""}`}
  id="why"
>
      <div className="why-choose-header">
  <h2>Why Choose DM Truck Parts?</h2>
  <p>
    Reliable parts, fast service and support for truck owners across the USA.
  </p>
</div>

<div className="why-choose-grid">
  <div className="why-card">
    <div className="why-icon">
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.83 2.83-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1.1V21h-4v-.1A1.7 1.7 0 0 0 8.6 19.4a1.7 1.7 0 0 0-1.88.34l-.06.06-2.83-2.83.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1.1-.4H3v-4h.1A1.7 1.7 0 0 0 4.6 8.6a1.7 1.7 0 0 0-.34-1.88l-.06-.06 2.83-2.83.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1.1V3h4v.1A1.7 1.7 0 0 0 15.4 4.6a1.7 1.7 0 0 0 1.88-.34l.06-.06 2.83 2.83-.06.06A1.7 1.7 0 0 0 19.4 9c.14.37.36.7.66.96.3.26.68.4 1.08.4H21v4h-.1A1.7 1.7 0 0 0 19.4 15Z" />
  </svg>
</div>
    <h3>OEM Quality</h3>
    <p>Reliable parts for heavy duty trucks and commercial vehicles.</p>
  </div>

  <div className="why-card">
    <div className="why-icon">
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 6h11v10H3z" />
    <path d="M14 10h4l3 3v3h-7z" />
    <circle cx="7" cy="18" r="2" />
    <circle cx="18" cy="18" r="2" />
    <path d="M14 18H9M3 18h2" />
  </svg>
</div>
    <h3>Fast Shipping</h3>
    <p>We help keep your trucks moving with fast order handling.</p>
  </div>

  <div className="why-card">
    <div className="why-icon">
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14.7 6.3a4 4 0 0 0-5-5L7.5 3.5l3 3 2.2-2.2a4 4 0 0 0 2 2Z" />
    <path d="M8.5 8.5 3 14a2.1 2.1 0 0 0 3 3l5.5-5.5" />
    <path d="m13 11 7.5 7.5a2.1 2.1 0 0 1-3 3L10 14" />
  </svg>
</div>
    <h3>Part Support</h3>
    <p>Need help? Send part number, VIN or photo and we will assist.</p>
  </div>

</div>

      </section>
{infoPage === "shipping" && (
  <section className="info-page" id="info-page">
    <div className="info-page-container">
      <button
        type="button"
        className="back-home-btn"
        onClick={() => {
  setInfoPage("");

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, 0);
}}
      >
        ← Back to Home
      </button>

      <h1>Shipping & Returns</h1>

      <div className="info-section">
        <h2>Shipping</h2>
        <p>
          DM Truck Parts ships truck parts and accessories throughout the
          United States. Shipping cost and delivery time may vary depending
          on the item, destination, size and weight of the shipment.
        </p>
        <p>
          Once your order has been processed and shipped, tracking
          information will be provided when available.
        </p>
      </div>

      <div className="info-section">
        <h2>Order Processing</h2>
        <p>
          We work to process orders as quickly as possible. Some heavy,
          oversized or special-order truck parts may require additional
          handling time.
        </p>
      </div>

      <div className="info-section">
        <h2>Returns</h2>
        <p>
          If you need to return an item, please contact DM Truck Parts before
          sending the product back. Returned items should be unused,
          undamaged and in their original condition whenever possible.
        </p>
      </div>

      <div className="info-section">
        <h2>Damaged or Incorrect Items</h2>
        <p>
          If your order arrives damaged or you receive the wrong item, please
          contact us as soon as possible with your order information and
          photos of the product so we can assist you.
        </p>
      </div>

      <div className="info-section">
        <h2>Need Help?</h2>
        <p>
          For shipping or return questions, contact us at{" "}
          <a href="mailto:info@dmtruckparts.com">
            info@dmtruckparts.com
          </a>
        </p>
      </div>
    </div>
  </section>
)}
{infoPage === "about" && (
  <section className="info-page" id="info-page">
    <div className="info-page-container">
      <button
        type="button"
        className="back-home-btn"
        onClick={() => {
          setInfoPage("");

          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          }, 0);
        }}
      >
        ← Back to Home
      </button>

      <h1>About DM Truck Parts</h1>

      <div className="info-section">
        <h2>Who We Are</h2>
        <p>
          DM Truck Parts supplies quality heavy-duty truck parts and
          accessories for truck owners, drivers and businesses across the
          United States. Our goal is to make finding the right truck part
          simple, fast and reliable.
        </p>
      </div>

      <div className="info-section">
        <h2>What We Offer</h2>
        <p>
          We provide a growing selection of suspension parts, filters, body
          parts, brake parts, chrome accessories, deer guards, valves and
          other heavy-duty truck components.
        </p>
      </div>

      <div className="info-section">
        <h2>Parts Support</h2>
        <p>
          Not sure which part you need? Send us your VIN, part number or a
          photo and our team will help you identify the right part for your
          truck.
        </p>
      </div>

      <div className="info-section">
        <h2>Our Commitment</h2>
        <p>
          We focus on reliable products, responsive customer service and
          straightforward ordering so our customers can keep their trucks
          moving.
        </p>
      </div>

      <div className="info-section">
        <h2>Contact Us</h2>
        <p>
          Need help? Contact us at{" "}
          <a href="mailto:info@dmtruckparts.com">
            info@dmtruckparts.com
          </a>
        </p>
      </div>
    </div>
  </section>
)}
{infoPage === "privacy" && (
  <section className="info-page" id="info-page">
    <div className="info-page-container">
      <button
        type="button"
        className="back-home-btn"
        onClick={() => {
          setInfoPage("");

          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          }, 0);
        }}
      >
        ← Back to Home
      </button>

      <h1>Privacy Policy</h1>

      <div className="info-section">
        <h2>Information We Collect</h2>
        <p>
          When you place an order or contact DM Truck Parts, we may collect
          information such as your name, email address, phone number and
          shipping address.
        </p>
      </div>

      <div className="info-section">
        <h2>How We Use Your Information</h2>
        <p>
          We use the information you provide to process orders, communicate
          with you about your order, provide customer support and improve
          our services.
        </p>
      </div>

      <div className="info-section">
        <h2>Shopping Cart</h2>
        <p>
          Our website may store shopping cart information in your browser
          so that your cart can remain available while you use the website.
        </p>
      </div>

      <div className="info-section">
        <h2>Payment Information</h2>
        <p>
          DM Truck Parts does not currently collect or store credit card
          information directly through this website.
        </p>
      </div>

      <div className="info-section">
        <h2>Information Sharing</h2>
        <p>
          We do not sell your personal information. Information may be
          shared with service providers only when necessary to operate our
          business, fulfill orders or provide requested services.
        </p>
      </div>

      <div className="info-section">
        <h2>Data Security</h2>
        <p>
          We take reasonable steps to protect the personal information
          submitted through our website from unauthorized access, use or
          disclosure.
        </p>
      </div>

      <div className="info-section">
        <h2>Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, contact us at{" "}
          <a href="mailto:info@dmtruckparts.com">
            info@dmtruckparts.com
          </a>
        </p>
      </div>
    </div>
  </section>
)}
{infoPage === "terms" && (
  <section className="info-page" id="info-page">
    <div className="info-page-container">
      <button
        type="button"
        className="back-home-btn"
        onClick={() => {
          setInfoPage("");

          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          }, 0);
        }}
      >
        ← Back to Home
      </button>

      <h1>Terms & Conditions</h1>

      <div className="info-section">
        <h2>General</h2>
        <p>
          By using the DM Truck Parts website, you agree to these Terms &
          Conditions. These terms apply to your use of the website and to
          orders placed through the website.
        </p>
      </div>

      <div className="info-section">
        <h2>Product Information</h2>
        <p>
          We make reasonable efforts to provide accurate product
          descriptions, images, prices and fitment information. Customers
          are responsible for confirming that a part is suitable for their
          vehicle before ordering.
        </p>
      </div>

      <div className="info-section">
        <h2>Orders</h2>
        <p>
          Orders are subject to product availability and confirmation.
          DM Truck Parts may contact customers if additional information is
          required to process an order.
        </p>
      </div>

      <div className="info-section">
        <h2>Pricing</h2>
        <p>
          Prices shown on the website are subject to change without notice.
          Shipping costs or other applicable charges may vary depending on
          the order and destination.
        </p>
      </div>

      <div className="info-section">
        <h2>Shipping & Returns</h2>
        <p>
          Shipping and returns are subject to the policies described on our
          Shipping & Returns page.
        </p>
      </div>

      <div className="info-section">
        <h2>Vehicle Fitment</h2>
        <p>
          Customers should verify part numbers, VIN information and vehicle
          compatibility before purchasing. If you are unsure which part you
          need, contact us before placing your order.
        </p>
      </div>

      <div className="info-section">
        <h2>Contact Us</h2>
        <p>
          If you have questions about these Terms & Conditions, contact us at{" "}
          <a href="mailto:info@dmtruckparts.com">
            info@dmtruckparts.com
          </a>
        </p>
      </div>
    </div>
  </section>
)}
  <footer className="footer">
  <div className="footer-content">
    <button
      type="button"
      className="footer-link"
      onClick={showAboutUs}
    >
      About Us
    </button>

    <button
      type="button"
      className="footer-link"
      onClick={showShippingReturns}
    >
      Shipping & Returns
    </button>
<button
  type="button"
  className="footer-link"
  onClick={showPrivacyPolicy}
>
  Privacy Policy
</button>
<button
  type="button"
  className="footer-link"
  onClick={showTermsConditions}
>
  Terms & Conditions
</button>
    <div>
      © 2026 DM Truck Parts. All Rights Reserved.
    </div>
  </div>
</footer>

</div>

);
}




export default App;